// extracted by mini-css-extract-plugin
module.exports = {"emergencyTicker":"alert-module--emergency-ticker--19oRS","marquee":"alert-module--marquee--az8eW","marqueeAnimation":"alert-module--marqueeAnimation--2Ur8U"};